module.exports = __webpack_public_path__ + "img/202311_09.20f9d0bc.jpg";